import $ from '../core/Dom';

export default el => {

    

};
